import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import queryparse from 'tricks/string/queryparse';
import createLocation from 'utils/createLocation';
import { getContentItemIconFromType } from 'utils/icons';
import getContentItemType, { getContentItemTypeTranslationKey } from 'utils/asset/getContentItemType';
import getContentProgress from 'utils/asset/getContentProgress';
import { isTeamManagerAndNotAdmin, getIsPlaylistEditable } from 'utils/privileges';
import getUserId from 'utils/session/getUserId';
import config from 'utils/config';
import formatRankForDisplay from 'utils/ui/formatRankForDisplay';
import checkIsAssetEditable from 'utils/checkIsAssetEditable';
import getPictureUrl, { DIMENSIONS } from 'utils/image/getPictureUrl';
import { checkIsAssetOrAuxiliaryContent, checkIsNestedPlaylist, checkIsPlaylist, checkIsTopic, checkIsPlaylistContent } from 'types/content/utils';
import useModalQueryParam from 'hooks/useModalQueryParam';
import { FILE_STATUS_VALUES } from 'actions/file';
import { useToggleSaveContent } from 'actions/content';
import { useUpdateAssets } from 'actions/assets';
import useProcessingFileStatus from 'actions/file/useProcessingFileStatus';
import FriendlyDuration from 'components/FriendlyDuration';
import InlineList from 'components/InlineList';
import { ExternalLink, InfoIcons, ProcessingStatus } from 'components/ContentCards';
import ContentProgressCircle from 'components/ContentProgressCircle';
import Button from 'components/Button';
import AssetEditor, { formatAssetEditorPayloadForApi } from 'screens/AssetEditor';
import ContentDeleteConfirmation from 'components/ContentDeleteConfirmation';
import { GoalPill, NextUpPill, SharedWithYouPill, LatestInteractionPill } from 'components/Pill';
import PlaylistEditorModal, { useSubmitPlaylistEditor } from 'screens/PlaylistEditorModal';
var isPlaylistSectionsEnabled = config.playlistSections;
var StyledCardButton = styled(Button).withConfig({
  displayName: "useCardController__StyledCardButton",
  componentId: "sc-1ldzqt6-0"
})(["background-color:transparent;"]);
export function useCardController(_ref) {
  var _contentItem$author;
  var isEditablePlaylist = _ref.isEditablePlaylist,
    collectionId = _ref.collectionId,
    priorityPillType = _ref.priorityPillType,
    _ref$progressInfoRead = _ref.progressInfoReadoutType,
    progressInfoReadoutType = _ref$progressInfoRead === void 0 ? 'full' : _ref$progressInfoRead,
    contentItem = _ref.contentItem,
    playlist = _ref.playlist,
    reset = _ref.reset,
    index = _ref.index,
    _ref$canRemoveFromPla = _ref.canRemoveFromPlaylist,
    canRemoveFromPlaylist = _ref$canRemoveFromPla === void 0 ? true : _ref$canRemoveFromPla,
    _ref$canSaveForLater = _ref.canSaveForLater,
    canSaveForLater = _ref$canSaveForLater === void 0 ? true : _ref$canSaveForLater,
    _ref$canEditPlaylist = _ref.canEditPlaylist,
    canEditPlaylist = _ref$canEditPlaylist === void 0 ? false : _ref$canEditPlaylist,
    onWebAssetClick = _ref.onWebAssetClick;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var id = contentItem.id,
    completion_time = contentItem.completion_time,
    commentCount = contentItem.commentCount,
    commentCountUser = contentItem.commentCountUser,
    domain_id = contentItem.domain_id,
    goal = contentItem.goal,
    ownerTeamId = contentItem.ownerTeamId,
    thumbnailId = contentItem.thumbnailId,
    isDisabled = contentItem.isDisabled,
    isDimmed = contentItem.isDimmed,
    userContentStatus = contentItem.userContentStatus;
  var latestInteraction = 'latestInteraction' in contentItem ? contentItem.latestInteraction : undefined;
  var _useModalQueryParam = useModalQueryParam("edit-content-".concat(id)),
    _useModalQueryParam2 = _slicedToArray(_useModalQueryParam, 2),
    hasContentEditor = _useModalQueryParam2[0],
    toggleContentEditor = _useModalQueryParam2[1];
  var _useModalQueryParam3 = useModalQueryParam("remove-content-".concat(id)),
    _useModalQueryParam4 = _slicedToArray(_useModalQueryParam3, 2),
    hasContentDeleteConfirmation = _useModalQueryParam4[0],
    toggleContentDeleteConfirmation = _useModalQueryParam4[1];
  var type = getContentItemType(contentItem);
  var isPlaylist = checkIsPlaylist(contentItem);
  var isNestedPlaylist = checkIsNestedPlaylist(contentItem, {
    parentPlaylist: playlist
  });
  var isTopic = checkIsTopic(contentItem);
  var isAssetOrAuxiliaryContent = checkIsAssetOrAuxiliaryContent(contentItem);
  var isAsset = !isPlaylist && !isTopic && !isNestedPlaylist;
  var content_count = isPlaylist ? contentItem.content_count : 0;
  var audience = isPlaylist ? contentItem.audience || 'all' : 'all';
  var badge = isPlaylist ? contentItem.badge : undefined;
  var hasUserBadge = isPlaylist ? contentItem.hasUserBadge : false;
  var completionRate = isPlaylist ? contentItem.completion_rate : 0;
  var collection_id = isAssetOrAuxiliaryContent ? contentItem.collection_id : undefined;
  var duration = isAssetOrAuxiliaryContent ? contentItem.duration : undefined;
  var fileId = isAssetOrAuxiliaryContent ? contentItem.fileId : undefined;
  var openInIframe = isAssetOrAuxiliaryContent ? contentItem.openInIframe : undefined;
  var userScormAssetStatus = isAssetOrAuxiliaryContent ? contentItem.userScormAssetStatus : undefined;
  var download = isAssetOrAuxiliaryContent ? contentItem.download : undefined;
  var isSaved = contentItem.isSaved;
  var location = useLocation();
  var getAssetLink = function getAssetLink() {
    var search = location.search,
      pathname = location.pathname;
    var searchParams = queryparse(search);
    if (contentItem.type === 'playlist') {
      return "/playlists/".concat(id);
    } else if (contentItem.type === 'topic') {
      return "browse/".concat(id);
    } else {
      return createLocation(pathname, _objectSpread(_objectSpread({}, searchParams), {}, {
        asset: id,
        collectionId: collectionId,
        isPublished: audience !== 'admin',
        modal: undefined,
        size: undefined
      }));
    }
  };
  var translatableType = getContentItemTypeTranslationKey(type);
  var icon = getContentItemIconFromType(type);
  var itemDuration = completion_time ? completion_time * 60 : duration;
  var isAssetOpenInPlaylist = !!(playlist !== null && playlist !== void 0 && playlist.id);
  var isContributingUserAuthor = getUserId() === ((_contentItem$author = contentItem.author) === null || _contentItem$author === void 0 ? void 0 : _contentItem$author.id);
  var isAssetEditable = checkIsAssetEditable(contentItem);
  var canUserRemoveAssetFromPlaylist = isAssetEditable && isAssetOpenInPlaylist && isContributingUserAuthor;
  var isContentEditablePlaylist = canEditPlaylist && isPlaylist && getIsPlaylistEditable(contentItem);
  var assetFileStatus = isAssetOrAuxiliaryContent ? contentItem.fileStatus : undefined;
  var _useProcessingFileSta = useProcessingFileStatus({
      fileId: fileId,
      parentPlaylistId: (playlist === null || playlist === void 0 ? void 0 : playlist.id) || collection_id,
      assetId: id,
      oldFileStatus: assetFileStatus,
      refetchInterval: 5000,
      assetFileStatus: assetFileStatus
    }),
    fileStatus = _useProcessingFileSta.fileStatus,
    isProcessingStatusShowing = _useProcessingFileSta.isProcessingStatusShowing;
  var assetMustBeDownloaded = download === 'required';
  var hasProcessingStatus = !isPlaylist && !assetMustBeDownloaded && isProcessingStatusShowing;
  var shouldShowAsNotAvailable = hasProcessingStatus && !isAssetEditable && !isContributingUserAuthor;
  var _useToggleSaveContent = useToggleSaveContent({
      id: contentItem.id,
      isSaved: !isSaved,
      isAsset: isAsset
    }),
    toggleSaveContent = _useToggleSaveContent.toggleSaveContent;
  function toggleSaved() {
    return _toggleSaved.apply(this, arguments);
  }
  function _toggleSaved() {
    _toggleSaved = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return toggleSaveContent({
              id: contentItem.id,
              isAsset: isAsset
            });
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _toggleSaved.apply(this, arguments);
  }
  var canSavePlaylist = isPlaylist && canSaveForLater;
  var menuItemsArray = [];
  if (isAsset || canSavePlaylist) {
    menuItemsArray.push({
      value: t(isSaved ? 'actions_remove_from_save_for_later' : 'actions_save_for_later'),
      icon: 'favourite',
      onSelect: toggleSaved
    });
  }
  if (!isPlaylistSectionsEnabled && (isAssetEditable || isContentEditablePlaylist)) {
    menuItemsArray.push({
      value: t('actions_edit'),
      icon: 'edit',
      onSelect: toggleContentEditor
    });
  }
  if (!isPlaylistSectionsEnabled && (isEditablePlaylist || canUserRemoveAssetFromPlaylist) && canRemoveFromPlaylist) {
    menuItemsArray.push({
      value: t('actions_remove_from_playlist'),
      icon: 'trash',
      onSelect: toggleContentDeleteConfirmation
    });
  }
  var progress = getContentProgress({
    isPlaylist: isPlaylist,
    userContentStatus: userContentStatus,
    userScormAssetStatus: userScormAssetStatus,
    completionRate: completionRate
  });

  // Only display as editable if user has edit privilege for playlist or asset but,
  // in the case of playlists, is also not an admin
  var showIsEditablePill = isPlaylist && isEditablePlaylist && isTeamManagerAndNotAdmin({
    domain_id: domain_id,
    ownerTeamId: ownerTeamId
  }) || isAssetEditable || isContentEditablePlaylist;
  var visibilityStatus;
  if (shouldShowAsNotAvailable) {
    visibilityStatus = 'unavailable';
  } else if (isPlaylist && audience === 'admin') {
    visibilityStatus = 'private';
  }
  var infoIcons = /*#__PURE__*/React.createElement(InfoIcons, {
    isSaved: isSaved,
    likeCount: contentItem.rating_count,
    hasUserLiked: contentItem.user_rated_like,
    visibility: visibilityStatus,
    isEditable: showIsEditablePill,
    commentCount: commentCount,
    commentCountUser: commentCountUser,
    isOptional: 'optional' in contentItem && contentItem.optional,
    playlistName: playlist === null || playlist === void 0 ? void 0 : playlist.name
  });
  var subtitle;
  if (shouldShowAsNotAvailable) {
    subtitle = t('content_currently_not_available');
  } else {
    subtitle = /*#__PURE__*/React.createElement(InlineList, {
      splitBy: "dot"
    }, /*#__PURE__*/React.createElement(React.Fragment, null, t(translatableType)), itemDuration && itemDuration > 0 && /*#__PURE__*/React.createElement(FriendlyDuration, {
      value: itemDuration
    }), isPlaylist && content_count && /*#__PURE__*/React.createElement(React.Fragment, null, t('playlist_item_count', {
      count: content_count
    })), type !== 'topic' && progress && /*#__PURE__*/React.createElement(ContentProgressCircle, {
      progress: progress,
      contentName: contentItem.name,
      infoReadout: progressInfoReadoutType,
      scale: 5 / 6
    }), contentItem.type === 'web' && openInIframe === false && /*#__PURE__*/React.createElement(ExternalLink, {
      webUrl: contentItem.webUrl || '',
      assetName: contentItem.name,
      onWasClicked: onWebAssetClick
    }), hasProcessingStatus && fileStatus && /*#__PURE__*/React.createElement(ProcessingStatus, {
      status: fileStatus
    }), hasProcessingStatus && fileStatus === FILE_STATUS_VALUES.INVALID && /*#__PURE__*/React.createElement(StyledCardButton, {
      z: "raised",
      size: "small",
      icon: "edit",
      mt: -4,
      onClick: toggleContentEditor,
      variant: "default-negative"
    }, t('actions_try_again')));
  }
  var _useUpdateAssets = useUpdateAssets({
      assetIds: [id],
      parentPlaylistId: playlist === null || playlist === void 0 ? void 0 : playlist.id,
      hasSuccessAlert: true
    }),
    updateAssets = _useUpdateAssets.updateAssets;
  function submitAssetEditor(_x) {
    return _submitAssetEditor.apply(this, arguments);
  }
  function _submitAssetEditor() {
    _submitAssetEditor = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2) {
      var changes, formattedData;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            changes = _ref2.changes;
            formattedData = formatAssetEditorPayloadForApi({
              changes: changes,
              parentPlaylistId: playlist === null || playlist === void 0 ? void 0 : playlist.id
            });
            _context2.next = 4;
            return updateAssets(formattedData);
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _submitAssetEditor.apply(this, arguments);
  }
  var _useSubmitPlaylistEdi = useSubmitPlaylistEditor({
      playlistId: id,
      parentPlaylistId: playlist === null || playlist === void 0 ? void 0 : playlist.id,
      badge: badge,
      ownerTeamId: contentItem.ownerTeamId,
      onSuccess: toggleContentEditor
    }),
    submitPlaylistEditor = _useSubmitPlaylistEdi.submitPlaylistEditor;
  function closeAssetEditor() {
    if (typeof reset === 'function') {
      reset();
    }
    toggleContentEditor();
  }
  var modalSlot = /*#__PURE__*/React.createElement(React.Fragment, null, hasContentDeleteConfirmation && /*#__PURE__*/React.createElement(ContentDeleteConfirmation, {
    asset: contentItem,
    playlistId: collectionId,
    onClose: toggleContentDeleteConfirmation
  }), hasContentEditor && (isPlaylist || isNestedPlaylist) && /*#__PURE__*/React.createElement(PlaylistEditorModal, {
    playlist: contentItem,
    parentPlaylist: playlist,
    onSubmit: submitPlaylistEditor,
    onClose: toggleContentEditor
  }), hasContentEditor && isAssetOrAuxiliaryContent && /*#__PURE__*/React.createElement(AssetEditor, {
    asset: contentItem,
    parentPlaylist: playlist,
    onClose: closeAssetEditor,
    onSubmit: submitAssetEditor
  }));
  var priorityPillMap = {
    next: /*#__PURE__*/React.createElement(NextUpPill, null),
    goal: goal ? /*#__PURE__*/React.createElement(GoalPill, {
      goal: goal
    }) : undefined,
    shared: /*#__PURE__*/React.createElement(SharedWithYouPill, null),
    latestInteraction: latestInteraction ? /*#__PURE__*/React.createElement(LatestInteractionPill, {
      latestInteraction: latestInteraction
    }) : undefined
  };
  var hasPlaylistNumbering = !!(playlist !== null && playlist !== void 0 && playlist.hasPlaylistNumbering);
  return {
    // `index` is used for old way of displaying the numbering of content in a playlist
    // Can most likely be removed when the playlistSections is fully implemented
    index: hasPlaylistNumbering ? index : undefined,
    hasPlaylistNumbering: hasPlaylistNumbering,
    infoIcons: infoIcons,
    badge: badge,
    hasUserBadge: hasUserBadge,
    priorityPill: priorityPillType ? priorityPillMap[priorityPillType] : undefined,
    description: contentItem.description,
    id: contentItem.id,
    icon: icon,
    imageSource: getPictureUrl({
      id: thumbnailId,
      dimensions: DIMENSIONS.HORIZONTAL_CARD
    }),
    isDisabled: hasProcessingStatus || isDisabled,
    isDimmed: hasProcessingStatus || isDimmed,
    link: getAssetLink(),
    menuItems: menuItemsArray.length ? menuItemsArray : undefined,
    title: contentItem.name,
    subtitle: subtitle,
    modalSlot: modalSlot,
    rank: checkIsPlaylistContent(contentItem) ? formatRankForDisplay(contentItem.rank) : undefined
  };
}